module.exports = __webpack_public_path__ + "img/4.70957595.jpg";